import { FC } from "react";
export type LoginScreenProps = {
  updateLevel: (newLevel: number) => void;
};
export const LoginScreen: FC<LoginScreenProps> = ({ updateLevel }) => {
  return (
    <div className="flex flex-col items-center justify-center p-10">
      <div className="w-max text-center mb-12">
        <h1
          className="animate-typing overflow-hidden whitespace-nowrap border-r-4 border-r-hackerGreen text-hackerGreen font-bold
         lg:text-5xl md:text-4xl text-3xl"
        >
          Welcome Hackers!
        </h1>
      </div>

      <p className="text-sm md:text-lg">
        You have been commisioned to do some pretty dastardly things.
      </p>
      <p className="mb-12 text-sm md:text-lg">
        Get through all the challenges and you may just see a reward in sight.
      </p>

      <button
        className="bg-transparent hover:bg-blue text-blue-dark font-semibold
       hover:text-black py-2 px-4 border border-hackerGreen hover:border-transparent hover:bg-hackerGreen rounded"
        onClick={() => updateLevel(1)}
      >
        Get Started!
      </button>
    </div>
  );
};
